import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`
export const TabWrapper = styled.div`
  flex: 0 0 auto;
  min-height: 0;
  min-width: 0;
`

export const Page = styled.div`
  overflow: auto;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
`
